module.exports = __webpack_public_path__ + "img/logo_北瓜.0515883b.png";